// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MenuFoldOutlinedSvg from "@fishx/icons-svg/es/asn/MenuFoldOutlined";
import FishxIcon from '../components/FishxIcon';

var MenuFoldOutlined = function MenuFoldOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MenuFoldOutlinedSvg
  }));
};

MenuFoldOutlined.displayName = 'MenuFoldOutlined';
export default React.forwardRef(MenuFoldOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MenuFoldOutlined.js
// module id = 3118
// module chunks = 0